module.exports = __webpack_public_path__ + "static/media/banner-3-meses.a5a81191.png";